module.exports = __webpack_public_path__ + "static/media/brilliwhite-5.f28a2e62.png";